// extracted by mini-css-extract-plugin
var _1 = "Table_bodyCell__W6cbM";
var _2 = "Table_bodyRow__G1PcZ";
var _3 = "Table_header__WBFXd";
var _4 = "Table_headerCell__TrcxX";
var _5 = "Table_headerRow__buU5w";
var _6 = "Table_table__s+zdR";
var _7 = "Table_wrapper__Nj7mm";
export { _1 as "bodyCell", _2 as "bodyRow", _3 as "header", _4 as "headerCell", _5 as "headerRow", _6 as "table", _7 as "wrapper" }
